export default __webpack_public_path__ + "static/media/small-is-powerful-banner-desktop.6b51f55b.jpg";